<template>
    <form action="#" class="main-form" @submit.prevent="postEffect()">
        <name-input :disabled="$store.getters.effectPostInProgress" v-if="showNameInput" v-model="name" :maxlength="$store.getters.visuals.maxNameLength" />
        <text-input :disabled="$store.getters.effectPostInProgress" v-if="showTextInput" v-model="text" :maxlength="$store.getters.visuals.maxTextLength" :placeholder="$t('forms.your_message')"/>
        <div v-if="showIncompleteCryptoPaymentForGenerationSessionNotice" class="payment-notice-row">
          <p>
            {{ $t('forms.incomplete_payment_for_sticker_creation_found') }}
            <a class="orange" role="button" @click="returnToCryptoPaymentForGenerationSession">
              {{ $t('forms.you_can_return_to_payment_form') }}
            </a>
          </p>
        </div>
        <div v-else-if="showCompletedPaymentForGenerationSessionNotice" class="payment-notice-row">
          <p>
            {{ $t('forms.completed_payment_for_sticker_creation_found') }}
            <router-link :to="generationURL" class="orange">
              {{ $store.getters.haveUnspentAttempts ? $t('forms.you_can_create_a_sticker') : $t('forms.you_can_select_one_of_the_stickers') }}
            </router-link>
          </p>
        </div>
        <div class="btn-row">
            <vue-recaptcha v-if="freeEffectMode" :sitekey="$store.getters.googleRecaptchaSiteKey" @verify="captchaVerify" @error="captchaError" ref="recaptcha">
              <button class="btn-orange" :disabled="!postingEnabled">
                {{ buttonLabel }}
              </button>
            </vue-recaptcha>
            <button class="btn-orange" :disabled="!postingEnabled" @click.prevent="postEffect()" v-else>
                {{ buttonLabel }}
            </button>
            <div class="text-error" v-if="error">{{error}}</div>
        </div>
    </form>
</template>

<script>

import TextInput from "@/components/general/TextInput/index";
import NameInput from "@/components/general/NameInput/index";
import { VueRecaptcha } from 'vue-recaptcha';
import { PostFreeEffectForSubscription, PostDonationEffect, PostFreeEffect } from "@/api/api";
import { EffectGenerationSessionStatus }from "@/store/models/EffectGenerationSession";

export default {
    name: 'EffectPostingForm',
    components: {
        NameInput,
        TextInput,
        VueRecaptcha,
    },
    data() {
        return {
            name: '',
            text: '',
            error: null,
            nameError: null,
            textError: null,
        };
    },
    computed: {
        freeEffectMode() {
            return this.$store.getters.paymentMode == 'free';
        },
        buttonLabel() {
          if (!this.$store.getters.paidMode) {
            return this.$t('forms.post_effect')
          } else if (this.showIncompleteCryptoPaymentForGenerationSessionNotice || this.showCompletedPaymentForGenerationSessionNotice) {
            return this.$t('forms.start_new_payment')
          }
          return this.$t('forms.initiate_payment')
        },
        showIncompleteCryptoPaymentForGenerationSessionNotice() {
            return this.$store.getters.effectGenerationSession?.cryptoPaymentDetails && this.$store.getters.selectedEffectIsPreset;
        },
        showCompletedPaymentForGenerationSessionNotice() {
            return this.$store.getters.effectGenerationSession?.status  === EffectGenerationSessionStatus.Paid && this.$store.getters.selectedEffectIsPreset;
        },
        generationURL() {
          return `/generate?session=${this.$store.getters.effectGenerationSession?.uuid}`
        },
        showNameInput() {
            if (this.$store.getters.donationOnlyMode || this.$store.getters.selectedEffectIsPreset){
                return false;
            }
            if (this.$store.getters.effectSelectorEnabled) {
                return this.selectedEffect?.nameAllowed;
            }
            return true;
        },
        showTextInput() {
            if (this.$store.getters.donationOnlyMode || this.$store.getters.selectedEffectIsPreset){
                return false;
            }
            if (this.$store.getters.effectSelectorEnabled) {
                return this.selectedEffect?.textAllowed;
            }
            return true;
        },
        postingEnabled() {
            if (this.$store.getters.effectPostInProgress) {
                return false;
            }
            if (this.freeEffectMode) {
                return this.$store.getters.secondsUntilNextFreeEffect <= 0;
            }
            if (this.$store.getters.effectSelectorEnabled) {
                if (!this.selectedEffect) {
                    return false;
                }
                if (this.$store.getters.paidMode) {
                    return this.$store.getters.total >= this.selectedEffect.minDonation;
                }
            } else {
                if (this.$store.getters.paidMode) {
                    return this.$store.getters.total > 0;
                }
            }
            return true;
        },
        selectedEffect() {
            for (let effect of this.$store.getters.effects) {
                if (effect.id == this.$store.getters.selectedEffect) {
                    return effect;
                }
            }
            return undefined;
        },
    },
    methods: {
        captchaVerify(captchaToken) {
          this.postEffect(captchaToken);
        },
        captchaError() {
          this.error = 'Произошла ошибка проверки капчи. Пожалуйста, обновите страницу и попробуйте ещё раз.';
          this.$refs.recaptcha?.reset();
        },
        returnToCryptoPaymentForGenerationSession() {
            this.$store.dispatch('returnToCryptoPaymentForGenerationSession');
        },
        postEffect(captchaToken) {
            this.error = null;
            this.nameError = null;
            this.textError = null;
            this.$store.dispatch('setEffectPostInProgress', true);
            let future = null;
            let effect = this.$store.getters.effectSelectorEnabled ? this.$store.getters.selectedEffect : null;
            if (this.$store.getters.paymentMode == 'subscription') {
                future = PostFreeEffectForSubscription(effect, this.name, this.text);
            } else if (this.$store.getters.paymentMode == 'donation') {
                future = PostDonationEffect(effect, this.name, this.text, this.$store.getters.total, this.$store.getters.channelCurrency, this.$store.getters.channelCurrency);
            } else if (this.$store.getters.paymentMode in this.$store.getters.allowedCryptocurrencies) {
                future = PostDonationEffect(effect, this.name, this.text, this.$store.getters.total, this.$store.getters.channelCurrency, this.$store.getters.paymentMode);
            } else if (this.freeEffectMode) {
                future = PostFreeEffect(effect, this.name, this.text, captchaToken);
            } else {
                this.$store.dispatch('setEffectPostInProgress', false);
                this.error = 'Не выбран способ оплаты';
            }
            future.then(function(response) {
                if (response.data.ok || response.data.success) {
                    this.text = '';
                    this.$router.push('/sent');
                } else if (response.data.error) {
                    this.error = response.data.error;
                } else if (response.data.redirect) {
                    window.location.href = response.data.redirect;
                    return;
                } else if (response.data.address && response.data.qr_code) {
                    var payment_data = {
                        address: response.data.address,
                        qr_code: response.data.qr_code,
                        address_uuid: response.data.address_uuid,
                        amount: response.data.amount,
                    }
                    this.$store.dispatch('startCryptoPayment', payment_data);
                    if (response.data.effect_generation_session) {
                        this.$store.dispatch('setEffectGenerationSession', response.data.effect_generation_session);
                    }
                }
                if (response.data.limits) {
                    this.$store.dispatch('setLimits', response.data.limits);
                }
                if (response.data.seconds_until_next_free_effect) {
                    this.$store.dispatch('setSecondsUntilNextFreeEffect', response.data.seconds_until_next_free_effect);
                }
                this.$refs.recaptcha?.reset();
                this.$store.dispatch('setEffectPostInProgress', false);
            }.bind(this)).catch(function(error) {
                this.$store.dispatch('setEffectPostInProgress', false);
                if (error.response && error.response.status == 400) {
                    let data = error.response.data;
                    this.error = data.error;
                    if (data.fieldError) {
                        this.nameError = data.fieldError.name;
                        this.textError = data.fieldError.text;
                    }
                    return;
                }
                this.error = 'При отправке эффекта возникла проблема. Попробуйте ещё раз.';
                this.$refs.recaptcha?.reset();
            }.bind(this));
        }
    }
};
</script>
<style lang="scss">
.payment-notice-row {
  margin-bottom: 20px;
  p {
    margin: 0;
    line-height: 1.2;
  }
  a {
    cursor: pointer;
  }
}
</style>
